import { connect } from 'react-redux'

import {
  fetchIngredientIssues,
  storeSelectedIngredientIssue,
  trackIngredientIssues,
} from 'actions/getHelp'

import { getSelectedIngredients } from '../selectors/selectors'
import { IngredientIssues } from './IngredientIssues.logic'

interface IngredientInfo {
  recipeId: string
  ingredientUuid: string
  issueId?: string
  issueName?: string
  label: string
}

interface IssueType {
  id: string
  label: string
  requireDescription: boolean
}

interface SubIssueType {
  id: string
  label: string
  groupLabel: string
  requireDescription: boolean
}

interface IngredientIssueInfo {
  recipeId: string
  ingredientName: string
  issueName: string
}

interface RootState {
  getHelp: any
}

interface StateProps {
  content: {
    title: string
    body: string
    button1Copy: string
  }
  ingredients: Record<string, IngredientInfo>
  issues: IssueType[]
  subIssues: SubIssueType[]
}

interface DispatchProps {
  fetchIngredientIssues: () => void
  storeSelectedIngredientIssue: (
    ingredientAndRecipeId: string,
    issueId: string,
    issueName: string,
  ) => void
  trackIngredientIssues: (ingredientIssuesInfo: IngredientIssueInfo[]) => void
}

const mapStateToProps = (state: RootState): StateProps => {
  const { getHelp } = state
  const ingredients = getSelectedIngredients(state)
  const issues = getHelp.get('ingredientIssues').toJS()
  const subIssues = getHelp.get('ingredientSubIssues').toJS()

  return {
    content: {
      title: 'Get help with your box',
      body: 'Please let us know what was wrong with the ingredient(s)',
      button1Copy: 'Continue',
    },
    ingredients,
    issues,
    subIssues,
  }
}

const mapDispatchToProps: DispatchProps = {
  fetchIngredientIssues,
  storeSelectedIngredientIssue,
  trackIngredientIssues,
}

const IngredientIssuesContainer = connect<
  StateProps,
  DispatchProps,
  Record<string, never>,
  RootState
>(
  mapStateToProps,
  mapDispatchToProps,
)(IngredientIssues)

export { IngredientIssuesContainer }
